import { onlyDigits } from './util';

function filterNonDigits(str = '') {
  return str.replace(/\D/g, '');
}

function updateHiddenDateField() {
  const dd = document.getElementById('lipDay').value;
  const mm = document.getElementById('select-dob-month').value;
  const yyyy = document.getElementById('lipYear').value;

  const yyyymmdd = `${yyyy}${mm}${dd}`;
  document.getElementById('lipDateOfBirth').value = yyyymmdd;
}

export function onKeyPressDay(event) {
  return onlyDigits(event);
}

export function onKeyUpDay(event) {
  const inValue = event.srcElement.value.trim();
  let outValue = filterNonDigits(inValue);
  if (outValue.length === 1) {
    if (outValue >= '4') {
      outValue = `0${outValue}`;
    }
  }
  if (outValue.length > 2) {
    outValue = outValue.substring(0, 2);
  }

  if (inValue !== outValue) {
    event.srcElement.value = outValue;
  }

  // Autofocus - removing for now
  // if (outValue.length === 2) {
  //   document.getElementById('select-dob-month').focus();
  // }
}

export function onChangeDay(event) {
  const inValue = event.srcElement.value.trim();
  let outValue = inValue;
  if (outValue.length === 1) {
    outValue = `0${outValue}`;
  }
  if (inValue !== outValue) {
    event.srcElement.value = outValue;
  }
  updateHiddenDateField();
}

export function onChangeYear(event) {
  updateHiddenDateField();
}

export function onKeyPressYear(event) {
  return onlyDigits(event);
}

export function onKeyUpYear(event) {
  const inValue = event.srcElement.value.trim();
  let outValue = filterNonDigits(inValue);
  if (outValue.length > 4) {
    outValue = outValue.substring(0, 4);
  }

  if (inValue !== outValue) {
    event.srcElement.value = outValue;
  }

  // Autofocus - Removing for now
  // if (outValue.length === 4) {
  //   document.getElementById('password').focus();
  // }
}

export function onChangeMonth(event) {
  updateHiddenDateField();
}

// Setup the aib namespace
const localWindow = window || {};
localWindow.aib = localWindow.aib || {};
const { aib } = localWindow;
aib.registration = {
  ...aib.registration,
  onKeyPressDay,
  onChangeDay,
  onKeyUpDay,
  onChangeMonth,
  onKeyPressYear,
  onChangeYear,
  onKeyUpYear,
};
